var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignSystems(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8234 14.1805C24.563 14.0617 24.2802 14.0002 23.994 14.0002C23.7078 14.0002 23.4249 14.0617 23.1645 14.1805L14.6001 18.0779C14.4227 18.1561 14.272 18.2842 14.1661 18.4466C14.0603 18.6089 14.0039 18.7985 14.0039 18.9924C14.0039 19.1862 14.0603 19.3758 14.1661 19.5381C14.272 19.7005 14.4227 19.8286 14.6001 19.9068L23.1745 23.8142C23.4349 23.933 23.7177 23.9945 24.0039 23.9945C24.2902 23.9945 24.573 23.933 24.8334 23.8142L33.4078 19.9168C33.5852 19.8386 33.7359 19.7105 33.8418 19.5481C33.9476 19.3858 34.004 19.1962 34.004 19.0023C34.004 18.8085 33.9476 18.6189 33.8418 18.4566C33.7359 18.2942 33.5852 18.1661 33.4078 18.0879L24.8234 14.1805Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 23.9941C14 24.1853 14.0544 24.3726 14.1571 24.5337C14.2598 24.6949 14.4066 24.8233 14.5801 24.9035L23.1745 28.811C23.4336 28.9283 23.7146 28.989 23.999 28.989C24.2833 28.989 24.5644 28.9283 24.8235 28.811L33.3979 24.9135C33.5748 24.834 33.7247 24.7048 33.8294 24.5415C33.9341 24.3783 33.989 24.1881 33.9875 23.9941",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 28.9908C14 29.182 14.0544 29.3693 14.1571 29.5304C14.2598 29.6916 14.4066 29.82 14.5801 29.9003L23.1745 33.8077C23.4336 33.925 23.7146 33.9857 23.999 33.9857C24.2833 33.9857 24.5644 33.925 24.8235 33.8077L33.3979 29.9102C33.5748 29.8307 33.7247 29.7015 33.8294 29.5382C33.9341 29.375 33.989 29.1848 33.9875 28.9908",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignSystems);
export default __webpack_public_path__ + "static/media/Design Systems.859d99dd02aabf72a8e0e283f588dc2f.svg";
export { ForwardRef as ReactComponent };